import { lazy } from "react";
import { useSelector } from "react-redux";
import { DialogContent } from "@mui/material";
import { RootState } from "../../../redux/store";

const TenderForm = lazy(() => import("./CreateTenderForm"));
const TenderDetails = lazy(() => import("./TenderDetails"));

const dialogsTypesWise: any = {
  "tendercreationform": () => <TenderForm />,
  "tenderdetails": () => <TenderDetails />
}

const dialogTypeFullScreen: any = { }

const TenderDialogPage: React.FC = () => {
    const { type, isFullScreen } = useSelector((state: RootState) => state.dialog);

    return (
        <>
            {
                (isFullScreen && dialogTypeFullScreen[type]?.()) ?
                    (
                        <DialogContent sx={{ height: "100%", margin: 0, padding: 0 }}  > {dialogTypeFullScreen[type]?.() ?? null} </DialogContent>
                    ) : (
                        <>
                            {dialogsTypesWise[type]?.() ?? null}
                        </>
                    )
            }
        </>
    )
}
export default TenderDialogPage;



